export default "__VITE_ASSET__kuf5x3KD__"